import landingImage01 from './../assets/images/landing-image-1.jpg';
import landingImage02 from './../assets/images/landing-image-2.jpg';
import landingImageSmall01 from './../assets/images/landing-image-mobile-01.jpg';
import landingImageSmall02 from './../assets/images/landing-image-mobile-02.jpg';

import bottomBkg from './../assets/images/ninja-logo-large.png';
import bottomBkgMobile from './../assets/images/ninja-logo-small.png';
import gradientBkg from './../assets/images/gradient-bkg.png';
import canBkg from './../assets/images/can-bkg.png';
import shadeBkg from './../assets/images/shade-bkg.png';
import smokeBkg from './../assets/images/smoke-bkg.png';

import prizeImage01 from './../assets/images/prize-1.png';
import prizeImage02 from './../assets/images/prize-2.png';
import prizeImage03 from './../assets/images/prize-3.png';

import prizeImageMobile01 from './../assets/images/prize-1-mobile.png';
import prizeImageMobile02 from './../assets/images/prize-2-mobile.png';
import prizeImageMobile03 from './../assets/images/prize-3-mobile.png';

export const heroCarouselImages = [
  landingImage01,
  landingImage02,
  landingImageSmall01,
  landingImageSmall02
];

export const backgroundImages = [
  bottomBkg,
  bottomBkgMobile,
  gradientBkg,
  canBkg,
  shadeBkg,
  smokeBkg,
];

export const prizeImages = {
  desktop: [
    prizeImage01,
    prizeImage02,
    prizeImage03,
  ],
  mobile: [
    prizeImageMobile01,
    prizeImageMobile02,
    prizeImageMobile03
  ]
};
